import { render, staticRenderFns } from "./Manutenzione.vue?vue&type=template&id=48f2d30f&scoped=true&"
import script from "./Manutenzione.vue?vue&type=script&lang=js&"
export * from "./Manutenzione.vue?vue&type=script&lang=js&"
import style0 from "./Manutenzione.vue?vue&type=style&index=0&id=48f2d30f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f2d30f",
  null
  
)

export default component.exports